var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
  "id": {
    "inject": false
  }
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/dist/idp/1786615270";
import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
import { ignoreSentryEvent } from './src/utils/sentryUtil';
var _getConfig = getConfig(),
  publicRuntimeConfig = _getConfig.publicRuntimeConfig;
var SENTRY_USE = publicRuntimeConfig.SENTRY_USE,
  SENTRY_DSN = publicRuntimeConfig.SENTRY_DSN,
  SENTRY_ENVIRONMENT = publicRuntimeConfig.SENTRY_ENVIRONMENT;
if (SENTRY_USE) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [],
    beforeSend: function beforeSend(event) {
      if (ignoreSentryEvent(event)) {
        return null;
      }
      return event;
    }
  });
}